const _i18n_msg = {
  login_info: {
    EN: `I've collected information! I'm leaving. It'3 seconds.`,
    KO : `정보수집 완료! 종료합니다. 3초뒤 종료됩니다..`,
    JP: `情報を収集しました。3秒後に離脱します`
  },
  login_description: {
    EN: `\n1. Choose an unique \n2. Input\nDon't forget!`,
    KO : "\n1. 고유값 선택 \n2. 입력 \n잊지마세요!",
    JP: `\n1. 一意の値を選択します \n2. \n 入力を忘れないでください!`
  },
  login_check_failed : {
    EN: `Couldn't collect site information. Please check the firewall status.`,
    KO : "사이트 정보를 수집하지 못했습니다 방화벽 상태를 확인해주세요",
    JP: `サイト情報を収集できませんでした。 ファイアウォールの状態を確認してください`
  },
  next_login_check : {
    EN: `I successfully collected data. Please move on.`,
    KO : "성공적으로 데이터를 수집하였습니다 다음으로 진행해주세요",
    JP: `無事にデータが集まりました。 先に進んでください`
  },
  login_scan_can_not : {
    EN: `The login page is a dynamic page.\nDynamic page login is not currently supported (preparing functionality)`,
    KO : "해당 로그인 페이지가 동적 페이지 입니다.\n현재 동적 페이지 로그인은 현재 지원하지 않습니다(기능 준비중)",
    JP: `ログイン ページは動的ページです。\n 動的ページ ログインは現在サポートされていません (機能を準備中)`
  },
  require_login_url : {
    EN: `required login URL(include http string)`,
    KO : "올바른 URL(http 포함) 을 입력해주세요",
    JP: `必須のログイン URL (http 文字列を含む)`
  },
  require_login_crawling : {
    EN: 'plz, Login Page crawling',
    KO : '로그인 페이지 정보를 수집 합니다',
    JP: 'ログインページのクロールをお願いします'
  },
  require_login : {
    EN: 'plz, press information gathering button',
    KO : '정보 수집 버튼을 클릭합니다',
    JP: '情報収集ボタンを押してください'
  },
  require_el_username : {
    EN: 'Press the ID entry part and select a unique character so that automation can be applied.',
    KO : '아이디 입력 부분을 누르고 자동화가 적용될 수 있도록 고유한 문자를 선택해주세요',
    JP: 'ID 入力部分を押して固有の文字を選択すると、自動化が適用されます'
  },
  require_username : {
    EN: 'plz, fill Username value',
    KO : 'id 를 입력하세요',
    JP: 'ユーザー名の値を入力してください'
  },
  require_el_password : {
    EN: 'Press the password input part and select a unique character so that automation can be applied.',
    KO : '패스워드 입력 부분을 누르고 자동화가 적용될 수 있도록 고유한 문자를 선택해주세요',
    JP: 'パスワード入力部分を押して固有の文字を選択すると、自動化が適用されます。'
  },
  require_password : {
    EN: 'plz, fill Password value',
    KO : '패스워드를 입력해주세요.',
    JP: 'パスワードの値を入力してください'
  },
  require_el_submit : {
    EN: 'plz, fill Login Button unique string',
    KO : '로그인 버튼을 눌러주세요',
    JP: 'ログインボタンの一意の文字列を入力してください'
  },
  exist_value : {
    EN: 'The value was duplicated',
    KO : '중복된 값이 존재합니다',
    JP: '値が重複しています'
  },
  login_input_setting : {
    EN: 'Please reset the input value or erase the input part',
    KO : '입력된 값을 초기화 하거나 입력할 부분을 지워주세요',
    JP: '入力値をリセットするか、入力部分を消去してください'
  },
}

const _i18n_warning = {
  login_check : {
    EN: `Login URL Check!`,
    KO: `Login URL Check!`,
    JP: `ログインURLチェック`
  },
  domain_check : {
    EN: `Domain Check`,
    KO: `Domain Check`,
    JP: `ドメインチェック`
  },
  schedule_check : {
    EN: `can not set every min`,
    KO: `can not set every min`,
    JP: `1分ごとに設定することはできません`
  },
  schedule_check_2 : {
    EN: `select the schedule`,
    KO: `select the schedule`,
    JP: `スケジュールを選択してください`
  },
  schedule_check_3 : {
    EN: `plz, Add Schedule`,
    KO: `plz, Add Schedule`,
    JP: `スケジュールを追加してください`
  },
  url_check : {
    EN: `URL Check`,
    KO: `URL Check`,
    JP: `URLチェック`
  },
  url_check_2 : {
    EN: `Check start URL Check`,
    KO: `Check start URL Check`,
    JP: `開始URLの確認`
  },
  subDomain_check : {
    EN: `Sub Domain Type Check`,
    KO: `Sub Domain Type Check`,
    JP: `サブドメインタイプのチェック`
  },
  FQDN_check : {
    EN: `FQDN Check`,
    KO: `FQDN Check`,
    JP: `FQDNチェック`
  },

  is_schedule : {
    EN: `Already existing`,
    KO: `Already existing`,
    JP: `すでに存在すしています`
  }
}

const _i18n_error = {
  sitename_check : {
    EN: `Invalid site name entered`,
    KO: `Invalid site name entered`,
    JP: `無効なサイト名が入力されました`
  },
  is_login : {
    EN: `required login info for login option`,
    KO: `required login info for login option`,
    JP: `ログインオプションに必要なログイン情報`
  },
  policyId_check : {
    EN: `Policy `,
    KO: `Policy `,
    JP: `ポリシー `
  },
  fqdn : {
    EN: `FQDN `,
    KO: `FQDN `,
    JP: `FQDN `
  },
  required_value : {
    EN: `Required value`,
    KO: `Required value`,
    JP: `必要な値`
  },
}

const _i18n_data = {
  _i18n_msg,
  _i18n_warning,
  _i18n_error
}

export default _i18n_data